<template>
  <v-navigation-drawer
    app
    right
    width="290"
    v-if="!isTV && !isFullscreen"
    v-model="drawerInput"
  >
    <v-toolbar flat>
      <v-toolbar-title>
        {{ labels.configure }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleConfigDrawer">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <perfect-scrollbar style="height: calc(100% - 64px)">
      <v-card flat class="transparent">
        <v-card-text>
          <theme />
          <v-select
          v-model="view"
          :items="views"
          :label="labels.selectView"
          outlined
          dense
          class="mt-4"
          ></v-select>
        </v-card-text>
      </v-card>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Theme from './Theme.vue';
import locale from '../locales/en.json';

export default {
  name: 'ConfigDrawer',
  components: {
    Theme,
  },
  computed: {
    ...mapState('helper', ['configDrawer', 'isFullscreen']),
    ...mapGetters('helper', ['isTV']),
    ...mapState('emsDashboard', ['selectedView', 'views']),
    labels() {
      return locale.dashboards;
    },
    drawerInput: {
      get() { return this.configDrawer; },
      set(val) { this.setConfigDrawer(val); },
    },
    view: {
      get() { return this.selectedView; },
      set(val) { this.setSelectedView(val); },
    },
  },
  methods: {
    ...mapMutations('helper', ['setConfigDrawer', 'toggleConfigDrawer']),
    ...mapMutations('emsDashboard', ['setSelectedView']),
  },
  mounted() {
    this.$nextTick(() => this.setConfigDrawer(false));
  },
};
</script>
